import { Grid, Typography } from '@mui/material'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { addAdeguataVerifica } from '../services/addAdeguataVerifica'
import CustomModal from '../UI/CustomModal'

import Header from '../UI/Header'

import { useTheme } from '@mui/material/styles'
import AdeguataVerificaFormV2 from './components/AdeguataVerificaFormV2'



const NuovaRichiestaForm = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [openCustomModal, setOpenCustomModal] = useState(false);
  const [disabilitaBottoneSalva, setDisabilitaBottoneSalva] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [infoMessage, setInfoMessage] = useState('');
  const [error, setError] = useState(false);

  const responseMessage = '';


  const handleSubmit = (event, params) => {
    setInfoMessage('')
    setError(false)
    setLoadingModal(true)
    setOpenCustomModal(true)
    setDisabilitaBottoneSalva(true)

    addAdeguataVerifica(params)
      .then(response => {
        if (response.data.code === 200) {
          setError(false)
          setLoadingModal(false)
          setInfoMessage(response.data.message)
          setTimeout(function () {
            navigate('/')
          }, 4000)
        }
      })
      .catch(error => {
        if (error.response.data.messageType === "ERROR") {

          setInfoMessage(error.response.data.message)
          setLoadingModal(true)
          setError(true)
          setDisabilitaBottoneSalva(true)
          setOpenCustomModal(true)
          setTimeout(function () {
            setInfoMessage('')
            setDisabilitaBottoneSalva(false)
            setOpenCustomModal(false)
          }, 6000)
        } else {
          setLoadingModal(false)
          setError(true)
          setInfoMessage('Campi inseriti non validi!')
          setTimeout(function () {
            setDisabilitaBottoneSalva(false)
            setOpenCustomModal(false)
            setError(false)
            setInfoMessage('')
          }, 4000)
        }
      })

  }

  return (
    <>
      <Header
        showHome
        showRichiesta={false}
        header={
          <>
            <Grid
              container
              columns={{ xs: 4, sm: 8, md: 12 }}
              justifyContent="center"
              alignItems="center"
              sx={{
                textAlign: 'center',
                height: '110px',
                //marginTop: '2rem',

              }}
            >
              <Typography
                sx={{ flexGrow: 1 }}
                color={theme.palette.black.main}
                variant="h1"
              >
                NUOVA RICHIESTA ADVR
              </Typography>
            </Grid>
          </>
        }
      />
      <AdeguataVerificaFormV2
        handleSubmit={(params, event) => handleSubmit(event, params)}
        errorState={error}
        responseMessage={responseMessage}
        disabilitaBottoneSalva={disabilitaBottoneSalva}
      />
      <CustomModal
        open={openCustomModal}
        loading={loadingModal}
        error={error}
        message={infoMessage}
      />
    </>
  )
}

export default NuovaRichiestaForm
